export type UmpireSocialMediaType = 'facebook' | 'instagram' | 'twitter' | 'tiktok';
